import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "sandbox";

const unwrap = (response) => {
  const data = response.data;
  if (!data.success) throw new Error(data.message || "Request failed");
  return data;
};

// Client for the sandbox-only sales scaling settings. On a normal (non-sandbox)
// server the GET simply returns { available: false } and this stays dormant.
export class SandboxService {
  async getConfig() {
    return unwrap(await axios.get(apiUrl, { withCredentials: true }));
  }

  async updateConfig({ mode, value }) {
    return unwrap(await axios.put(apiUrl, { mode, value }, { withCredentials: true }));
  }
}
